import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, ViewChild } from '@angular/core';
import { GenericManage, GenericManageViewMode } from '../../generic/generic.manage';
import { Division } from '../../../model/api/administration/division';
import { Administration } from '../../../model/api/administration/administration';

import { AdministrationHttpService } from '../../../services/http/administration/administration.http.service';
import { AdministrationDetailHttpService } from '../../../services/http/administration/administration-detail.http.service';
import { AdministrationDetailComponent as AdministrationDetailUI } from './administration.detail';
import { AdministrationDetail } from '../../../model/api/administration/administration-detail';
import { DivisionHttpService } from '../../../services/http/administration/division.http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AdministrationListComponent } from './administration.list';
import { DivisionListComponent } from '../divisions/division.list';
import { AppUtils } from '../../../common/app.utils';

@Component({
    selector: 'app-administration-manage',
    templateUrl: 'administration.manage.html',
    providers: [ DivisionHttpService, AdministrationHttpService, AdministrationDetailHttpService ]
})
export class AdministrationManageComponent extends GenericManage<Administration, number> {

    @ViewChild('administrationDetailModal') administrationDetailModal: ModalDirective;
    @ViewChild('administrationList') administrationList: AdministrationListComponent;
    @ViewChild('administrationDetail') administrationDetail: AdministrationDetailUI;
    @ViewChild('divisionListModal') divisionListModal: ModalDirective;
    @ViewChild('divisionList') divisionList: DivisionListComponent;

    isCollapsed: boolean = true;
    public filter: string = '';
    public selectedDivision: Division = null;

    constructor(public divisionHttpService: DivisionHttpService, public administrationHttpService: AdministrationHttpService,
        public administrationDetailHttpService: AdministrationDetailHttpService) {

        super();
    }

    public addNewItem() {
        super.addNewItem();

        this.administrationDetail.division = null;
    }

    public editItem() {
        super.editItem();

        const administration: AdministrationDetail = this.selectedItem as AdministrationDetail;

        this.administrationDetail.division = null;
        if (administration != null && administration.division != null) {
            this.divisionHttpService
                .getById(administration.division.id)
                .subscribe((division: Division) => {
                    this.administrationDetail.division = division;
                });
        }
    }

    public detailInitialize() {
        super.detailInitialize();
        this.administrationDetailModal.show();
    }

    public detailTerminate() {
        super.detailTerminate();
        this.administrationDetailModal.hide();
    }

    public onAdministrationDetailDivisionNeeded() {
        this.administrationDetailModal.hide();
        this.selectDivision();
    }

    public onDivisionListCancel() {
        this.divisionListModal.hide();
        if (this.viewMode === GenericManageViewMode.ItemDetail) {
            this.administrationDetailModal.show();
        }
    }

    public refresh() {
        let params: Array<Param> = new Array<Param>();

        params.push(new Param('filter', this.filter));
        params.push(new Param("divisionIds", AppUtils.getIdsList<Division, number>([ this.selectedDivision ])));

        this.administrationList.refresh(params);
    }

    public selectDivision() {
        this.divisionListModal.show();
        this.divisionList.refresh(null);
    }

    public setSelectedDivision() {
        switch(this.viewMode) {
            case GenericManageViewMode.ItemList:
                this.selectedDivision = this.divisionList.selectedItem;
                this.divisionListModal.hide();
                this.refresh();
                break;
            case GenericManageViewMode.ItemDetail:
                this.administrationDetail.division = this.divisionList.selectedItem;
                this.divisionListModal.hide();
                this.administrationDetailModal.show();
                break;
        }
    }

    public unselectDivision() {
        this.selectedDivision = null;
        this.refresh();
    }

    public exportToExcel() {

         let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.administrationDetailHttpService.get(1, 1000000, 'code', 'asc', params, null).subscribe(
            (data: PagedResult<Administration>) => {

                let options = {
                    sheetid: 'Administrare',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // let res = alasql(`SELECT id as [Id], 
                //                     code as [Cod], 
                //                     name as [Denumire], 
                //                     divisionName as [Cladire]
                //                     INTO XLSX("Centre de cost.xlsx",?) FROM ?`,[ options, data.items ]);

            });
    }


    collapsed(event: any): void {
        // console.log(event);
      }
    
      expanded(event: any): void {
        // console.log(event);
      }
}
